import { keyBy } from 'lodash';
import * as actionTypes from './actionTypes';

export function fetchSettings(payload) {
  return { type: actionTypes.FETCH_SETTINGS, payload };
}

export function fetchSettingsSuccess(payload) {
  const byId = keyBy(payload, (setting) => (setting.schoolUid));
  return { type: actionTypes.FETCH_SETTINGS_SUCCESS, payload: { byId } };
}